import { Telescope } from '@apollo/space-kit/illustrations/Telescope';
import React from 'react';

import {
  CurrentFieldAccessBounds,
  CurrentFieldEmptyState,
} from '../../useCurrentField';
import { NoFieldUsage } from '../noFieldUsage/NoFieldUsage';

interface Props {
  accessBounds: CurrentFieldAccessBounds;
  emptyState: CurrentFieldEmptyState;
}

export const NoClientMetrics = ({ accessBounds, emptyState }: Props) => (
  <div className="flex flex-col items-center justify-center p-12">
    <Telescope className="mb-4" />
    <NoFieldUsage accessBounds={accessBounds} emptyState={emptyState} />
  </div>
);
